export const EVENT = {
  COMPLETE: "complete",
};

export const STATE = {
  NEUTRAL: {
    KEY: "NEUTRAL",
    VALUE: 0,
  },
  STREAK: {
    KEY: "STREAK",
    VALUE: 2,
  },
  SUCCESS: {
    KEY: "SUCCESS",
    VALUE: 12,
  },
  FAIL: {
    KEY: "FAIL",
    VALUE: [12, 25],
  },
};
